import { useRef, useState } from "react";
import { Input } from "@sajari/react-search-ui";
import './app.css';

function App({ resultsPage }) {
  const [searchValue, setSearchValue] = useState("");
  const inputRef = useRef();
  const searchBoxInput = document.querySelector('.search-bar__input');
  const suggestionBox = document.querySelector("#suggestions");

  const handleSubmit = (e) => {
    e.preventDefault();
    window.location.href = `${resultsPage}?q=${searchValue}`;
  };

  return (
    <div className="search-bar">
      <form className="search-bar__form" onSubmit={handleSubmit}>
        <Input
          inputElement={inputRef}
          showPoweredBy={false}
          mode="suggestions"        
          portalContainer={suggestionBox}
        />
        <input 
         className="search-bar__input"
         placeholder="enter search keywords..."
          ref={inputRef}
          onKeyUp={(e) => {
            setSearchValue(e.currentTarget.value);
          }} 
        />
        <button className="search-bar__submit" onClick={(e) => {setSearchValue(searchBoxInput.value)}}>
          <svg class="icon icon-search" focusable="false" aria-hidden="true">
            <use href="/ResourcePackages/Talon/assets/dist/sprites/svgdefs.svg#icon-search"></use>
          </svg>
        </button>
      </form>
    </div>
  );
}

export default App;
